import { render, staticRenderFns } from "./ESGReportTaskStatus.vue?vue&type=template&id=4fdb6657&"
import script from "./ESGReportTaskStatus.vue?vue&type=script&lang=js&"
export * from "./ESGReportTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports